import { DocumentDuplicateIcon, RectangleStackIcon } from "@heroicons/react/24/outline"
import { Navigate, Route, Routes, } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import { TemplateListing } from "./TemplateManagement"
import { AddUpdateTemplate } from "./TemplateManagement/AddUpdateTemplate"
import { PagesListing } from "./PageManagement"
import { AddUpdatePages } from "./PageManagement/AddUpdatePages"
import RouteKeys from "constants/route-keys"

const _routes: RouteElement[] = [
    {
        key: RouteKeys.TEMPLATE,
        route: 'template-management',
        title: 'Template Management',
        component: TemplateListing,
        icon: RectangleStackIcon,
        display: true
    },
]

const WidgetManagement = () => {
    return (
        <div>
            <SubMenuTabs _routes={_routes} />
            <div className="p-3">
                <Routes>
                    <Route path="" element={<Navigate to="template-management" replace />} />

                    <Route path="template-management">
                        <Route index element={<TemplateListing />} />
                        <Route path="create-template" element={<AddUpdateTemplate mode="create" />} />
                        <Route path="update-template/:id" element={<AddUpdateTemplate mode="edit" />} />
                    </Route>

                    <Route path="" element={<Navigate to="page-management" replace />} />
                    <Route path="page-management">
                        <Route index element={<PagesListing />} />
                        <Route path="create-page" element={<AddUpdatePages mode="create" />} />
                        <Route path="update-page/:id" element={<AddUpdatePages mode="edit" />} />
                    </Route>

                </Routes>
            </div>
        </div>
    );
};

export default WidgetManagement;
